export function productForPath(path) {
  if (/ielts/i.test(path)) return 'ielts';
  if (/^\/(?:pte(?:\/|-|$)|mocktest(?:\/|$)|writing(?:\/|$)|reading(?:\/|$)|listening(?:\/|$)|speaking(?:\/|$))/i.test(path)) return 'pte';
  return 'general';
}

export function acquisitionForLocation(search = '', referrer = '') {
  const params = new URLSearchParams(String(search || '').slice(0, 1000));
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  const utmCampaign = params.get('utm_campaign');
  if (utmSource || utmMedium || utmCampaign) {
    return {
      acquisition_source: 'campaign',
      ...(utmSource ? { utm_source: utmSource.slice(0, 80) } : {}),
      ...(utmMedium ? { utm_medium: utmMedium.slice(0, 80) } : {}),
      ...(utmCampaign ? { utm_campaign: utmCampaign.slice(0, 160) } : {}),
    };
  }

  if (!referrer) return { acquisition_source: 'direct' };
  try {
    const referrerHost = new URL(referrer).hostname.toLowerCase().slice(0, 160);
    return {
      acquisition_source: /(^|\.)google\./.test(referrerHost) ? 'google' : 'referral',
      referrer_host: referrerHost,
    };
  } catch (_) {
    return { acquisition_source: 'direct' };
  }
}

export function deviceCategoryForWidth(width) {
  if (Number(width) < 768) return 'mobile';
  if (Number(width) < 1200) return 'tablet';
  return 'desktop';
}

export function browserFamily(userAgent = '') {
  const value = String(userAgent).toLowerCase();
  if (/edg\//.test(value)) return 'edge';
  if (/opr\//.test(value)) return 'opera';
  if (/firefox\//.test(value)) return 'firefox';
  if (/chrome\//.test(value)) return 'chrome';
  if (/safari\//.test(value)) return 'safari';
  return 'other';
}

function isActiveTestPath(path) {
  return /^\/(?:pte|ielts)\/mock-tests\/[^/]+\/[^/]+/i.test(path)
    || /^\/ielts-(?:listening|reading|writing|speaking|full)-test\/?$/i.test(path);
}

export function transitionEventsForNavigation(previousPath, currentPath, currentState = {}) {
  const events = [];
  if (
    previousPath === '/checkout'
    && !/^\/(?:checkout-pay-with-bank-account|payment(?:-success|\/status))(?:\/|$)/i.test(currentPath)
  ) {
    events.push('checkout_abandoned');
  }

  if (
    isActiveTestPath(previousPath || '')
    && previousPath !== currentPath
    && !isActiveTestPath(currentPath)
    && !/results?|score|test-details/i.test(currentPath)
  ) {
    events.push('test_abandoned');
  }

  if (
    isActiveTestPath(currentPath)
    && (currentState.resumeDraft || currentState.requestedMode === 'resume' || currentState.resumeFullTestAttemptId)
  ) {
    events.push('test_resumed');
  }
  return events;
}

export function analyticsEventForPath(path) {
  if (/dashboard/i.test(path)) return 'dashboard_view';
  if (/results?|score|ielts-test-details/i.test(path)) return 'results_view';
  if (/^\/payment(?:-success|\/status)/i.test(path)) return 'payment_status_viewed';
  if (/subscriptions?|^\/(?:sidebar|plan-info)\/?$/i.test(path)) return 'subscription_page_viewed';
  if (
    /^\/(?:pte|ielts)\/mock-tests\/[^/]+\/[^/]+/i.test(path)
    || /^\/ielts-(?:listening|reading|writing|speaking|full)-test\/?$/i.test(path)
  ) return 'test_started';
  if (/^\/(?:writing|reading|listening|speaking)\/.+/i.test(path)) return 'practice_question_opened';
  if (/^\/mocktest(?:\/|$)|^\/(?:writing|reading|listening|speaking)\/?$/i.test(path)) return 'test_list_viewed';
  return null;
}
